import Enum from "../../../../../../enums/Enum";

const TypeEnum = new Enum({
    ACTIVE: {name: "Active", nameInArabic: "نشيط"},
    SEDENTARY: {name: "Sedentary", nameInArabic: "كثير الجلوس"},
    RECREATIONAL: {name: "Recreational", nameInArabic: "ممارس لأنشطة ترفيهية/ ترويحية"}
});

export default TypeEnum;